/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AddMetaMcpMemberForm,
  AddMetaMcpMemberForm$Outbound,
  AddMetaMcpMemberForm$outboundSchema,
} from "../components/addmetamcpmemberform.js";

export type AddMetaMcpMemberSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AddMetaMcpMemberSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AddMetaMcpMemberSecurity = {
  option1?: AddMetaMcpMemberSecurityOption1 | undefined;
  option2?: AddMetaMcpMemberSecurityOption2 | undefined;
};

export type AddMetaMcpMemberRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  addMetaMcpMemberForm: AddMetaMcpMemberForm;
};

/** @internal */
export type AddMetaMcpMemberSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AddMetaMcpMemberSecurityOption1$outboundSchema: z.ZodMiniType<
  AddMetaMcpMemberSecurityOption1$Outbound,
  AddMetaMcpMemberSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function addMetaMcpMemberSecurityOption1ToJSON(
  addMetaMcpMemberSecurityOption1: AddMetaMcpMemberSecurityOption1,
): string {
  return JSON.stringify(
    AddMetaMcpMemberSecurityOption1$outboundSchema.parse(
      addMetaMcpMemberSecurityOption1,
    ),
  );
}

/** @internal */
export type AddMetaMcpMemberSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AddMetaMcpMemberSecurityOption2$outboundSchema: z.ZodMiniType<
  AddMetaMcpMemberSecurityOption2$Outbound,
  AddMetaMcpMemberSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function addMetaMcpMemberSecurityOption2ToJSON(
  addMetaMcpMemberSecurityOption2: AddMetaMcpMemberSecurityOption2,
): string {
  return JSON.stringify(
    AddMetaMcpMemberSecurityOption2$outboundSchema.parse(
      addMetaMcpMemberSecurityOption2,
    ),
  );
}

/** @internal */
export type AddMetaMcpMemberSecurity$Outbound = {
  Option1?: AddMetaMcpMemberSecurityOption1$Outbound | undefined;
  Option2?: AddMetaMcpMemberSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AddMetaMcpMemberSecurity$outboundSchema: z.ZodMiniType<
  AddMetaMcpMemberSecurity$Outbound,
  AddMetaMcpMemberSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => AddMetaMcpMemberSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => AddMetaMcpMemberSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function addMetaMcpMemberSecurityToJSON(
  addMetaMcpMemberSecurity: AddMetaMcpMemberSecurity,
): string {
  return JSON.stringify(
    AddMetaMcpMemberSecurity$outboundSchema.parse(addMetaMcpMemberSecurity),
  );
}

/** @internal */
export type AddMetaMcpMemberRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AddMetaMcpMemberForm: AddMetaMcpMemberForm$Outbound;
};

/** @internal */
export const AddMetaMcpMemberRequest$outboundSchema: z.ZodMiniType<
  AddMetaMcpMemberRequest$Outbound,
  AddMetaMcpMemberRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    addMetaMcpMemberForm: AddMetaMcpMemberForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      addMetaMcpMemberForm: "AddMetaMcpMemberForm",
    });
  }),
);

export function addMetaMcpMemberRequestToJSON(
  addMetaMcpMemberRequest: AddMetaMcpMemberRequest,
): string {
  return JSON.stringify(
    AddMetaMcpMemberRequest$outboundSchema.parse(addMetaMcpMemberRequest),
  );
}
